// extracted by css-extract-rspack-plugin
export default {"heroImage":"WelcomeSplashDialog-module__heroImage__igOOv","body":"WelcomeSplashDialog-module__body__psD1P"};